import { IPathfindingHeuristic } from "./IPathfindingHeuristic";
import { PathfindingGraph } from "./PathfindingGraph";

/**
 * A heuristic that does not influence the pathfinder in any way, causing the search to spread evenly in all directions.
 * <p>Use it if there could be multiple, scattered target nodes - e.g. if you search for the nearest food source etc.</p>
 * @author npuschke
 *
 */
export class PathfindingHeuristicNone implements IPathfindingHeuristic {
    /**
     * Creates a heuristic that does not influence the Pathfinder at all.
     *
     */
    constructor() {
    }

    /**
     * Calculates the heuristic value at the given coordinates.
     * @param graph The graph that is being searched.
     * @param x The horizontal coordinate of the node to be calculated.
     * @param y The vertical coordinate of the node to be calculated.
     * @return The heuristic value of the node.
     */
    public calculate(graph: PathfindingGraph, x: number, y: number): number {
        return 0;
    }
}

